/**
 * Master on/off switch for the in-app "Getting Started" walkthrough — the
 * progress Widget, per-page Callouts, spotlight MicroTours, section-editor
 * tours, modal tours, and the /admin/getting-started page.
 *
 * Turned OFF for now: the guided walkthrough wasn't functioning reliably.
 * All of the code is left in place so it can be brought back simply by
 * flipping this to `true` (and rebuilding). Every entry point gates on this
 * flag, so there's nothing else to re-wire:
 *   - components/global/Layout.tsx          (Widget + Callout)
 *   - components/admin/Section/SectionLayout.tsx        (SectionTypeTour)
 *   - components/admin/Section/Navs/SectionTopbar.tsx   (tour button)
 *   - components/admin/Section/Navs/ClassSettings.tsx   (ModalTour)
 *   - pages/admin/getting-started.tsx       (full checklist page)
 */
// Typed as `boolean` (not the literal `false`) on purpose: it keeps
// TypeScript from narrowing the gates into "unreachable"/"always-false"
// dead code at every call site, and from flagging the early return in the
// getting-started page. Flip to `true` to bring the walkthrough back.
export const WALKTHROUGH_ENABLED = false;
